import { callAPI } from "../../network/networkConnection";
import { NetworkConfiguration } from "../../network/networkConfriguation";

const buildQuery = (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    query.append(key, value);
  });
  const qs = query.toString();
  return qs ? `?${qs}` : "";
};

const getInquiries = (params = {}) => {
  return callAPI(
    process.env.REACT_APP_APIUrl + NetworkConfiguration.ADMIN_INQUIRIES + buildQuery(params),
    "GET",
    { "Content-Type": "application/json" }
  );
};

const getInquiryById = (id) => {
  return callAPI(
    `${process.env.REACT_APP_APIUrl + NetworkConfiguration.ADMIN_INQUIRIES}/${id}`,
    "GET",
    { "Content-Type": "application/json" }
  );
};

const updateInquiry = (id, payload = {}) => {
  return callAPI(
    `${process.env.REACT_APP_APIUrl + NetworkConfiguration.ADMIN_INQUIRIES}/${id}`,
    "PATCH",
    { "Content-Type": "application/json" },
    JSON.stringify(payload)
  );
};

const replyToInquiry = (id, payload = {}) => {
  return callAPI(
    `${process.env.REACT_APP_APIUrl + NetworkConfiguration.ADMIN_INQUIRIES}/${id}/reply`,
    "POST",
    { "Content-Type": "application/json" },
    JSON.stringify(payload)
  );
};

const addNote = (id, payload = {}) => {
  // payload: { adminName, note }
  return callAPI(
    `${process.env.REACT_APP_APIUrl + NetworkConfiguration.ADMIN_INQUIRIES}/${id}/notes`,
    "POST",
    { "Content-Type": "application/json" },
    JSON.stringify(payload)
  );
};

// Contact Us list for admin 
const getContacts = (params = {}) => {
  return callAPI(
    process.env.REACT_APP_APIUrl +
      NetworkConfiguration.ADMIN_CONTACTS +
      buildQuery(params),
    "GET",
    { "Content-Type": "application/json" }
  );
};


// contact detail
const getContactById = (id) => {
  return callAPI(
    `${process.env.REACT_APP_APIUrl + NetworkConfiguration.ADMIN_CONTACTS}/${id}`,
    "GET",
    { "Content-Type": "application/json" }
  );
};

// reply to contact
const replyToContact = (id, payload = {}) => {
  return callAPI(
    `${process.env.REACT_APP_APIUrl + NetworkConfiguration.ADMIN_CONTACTS}/${id}/reply`,
    "POST",
    { "Content-Type": "application/json" },
    JSON.stringify(payload)
  );
};

//  add contact note
const addContactNote = (id, payload = {}) => {
  return callAPI(
    `${process.env.REACT_APP_APIUrl + NetworkConfiguration.ADMIN_CONTACTS}/${id}/notes`,
    "POST",
    { "Content-Type": "application/json" },
    JSON.stringify(payload)
  );
};

const updateContactStatus = (id, payload = {}) => {
  return callAPI(
    `${process.env.REACT_APP_APIUrl + NetworkConfiguration.ADMIN_CONTACTS}/${id}/status`,
    "PATCH",
    { "Content-Type": "application/json" },
    JSON.stringify(payload)
  );
};

export const InquiryService = {
  getInquiries,
  getInquiryById,
  updateInquiry,
  replyToInquiry,
  addNote,

  // Contact Us
  getContacts,
  getContactById,
  replyToContact,
  addContactNote,
  updateContactStatus,
};

